/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Header } from '../Header'
import { Footer } from '../Footer'

import 'typeface-exo-2'
import '../../scss/base.scss'

export const Layout: React.FC = ({ children }) => (
  <div className={'wrapper'}>
    <Header />
    <>{children}</>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}
